<template>
  <div>
    <v-card class="pa-5">
      <v-card-text>
        <v-card-title>
            <h4>{{$t('reports.inspectionReportInspector')}}</h4>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="filterData()" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                  <v-icon small>fas fa-search</v-icon>
                </v-btn>
              </template>
              <span>{{$t('general.search')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="resetFilter" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                  <v-icon small>fa-solid fa-eraser</v-icon>
                </v-btn>
              </template>
              <span>{{$t('general.resetFilter')}}</span>
            </v-tooltip>
            <v-btn v-if="report2.length > 0" @click="download" :loading="loadingButton" class="mr-2" color="primary">
              {{$t('reports.downloadReport')}}
              <v-icon small class="ml-2">fas fa-cloud-download-alt</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form v-model="valid" lazy-validation ref="form">
            <v-row dense>
              <v-col cols="3">
                <v-autocomplete
                  clearable
                  outlined
                  dense
                  :items="users"
                  :item-text="getInspector" 
                  item-value="id"
                  v-model="filter.inpector"
                  multiple
                  label="Inspector"
                  class="mb-4 ml-2">
                  <template v-slot:selection="data">
                    <v-chip small color="primary">
                      {{ data.item.name }} {{ data.item.last_name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  clearable
                  outlined
                  dense
                  :items="sites"
                  item-text="name"
                  item-value="id"
                  v-model="filter.site"
                  :label="$t('general.yard')"
                  class="mb-4 ml-2"/>
              </v-col>
              <v-col v-if="filter.dateRange" cols="2">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.date_start"
                      :label="$t('general.startDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    no-title
                    color="primary"
                    v-model="filter.date_start"
                    @input="handleDateStartSelection"
                    :allowed-dates="allowedStartDates"
                    :day-style="getDayStyle"
                  />
                </v-menu>
              </v-col>
              <v-col v-if="filter.dateRange" cols="2">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.date_end"
                      :label="$t('general.endDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    no-title
                    color="primary"
                    v-model="filter.date_end"
                    @input="menu2 = false"
                    :allowed-dates="allowedEndDates"
                    :day-style="getDayStyle"
                  />
                </v-menu>
              </v-col>
              <v-col cols="2">
                <v-checkbox v-model="filter.dateRange" :label="$t('general.dateRange')" class="mt-0" hide-details color="primary"/>
              </v-col>
              <!-- <v-col class="float-right" cols="12">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="filterData()" v-on="on" v-bind="attrs" depressed class="float-right" color="primary">
                      <v-icon small>fas fa-search</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('general.search')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="resetFilter" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                      <v-icon small>fa-solid fa-eraser</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('general.resetFilter')}}</span>
                </v-tooltip>
              </v-col> -->
            </v-row>
          </v-form>
        </v-card-text>
        <v-overlay absolute opacity="0" :value="loadingTable"/>
        <v-data-table
          :loading="loadingTable"
          :loading-text="$t('general.loading')"
          :headers="headers"
          :items="report2"
          :single-expand="false"
          :server-items-length="optionsDataTable.totalItems"
          :options.sync="optionsDataTable"
          :footer-props="{ 'items-per-page-options': [50, 70, 100] }"
          @update:page="get"
          @update:items-per-page="get"
          @update:sort-by="get"
          @update:sort-desc="get"
          item-key="id"
        >
          <template v-slot:item.user:name="{ item }">
            {{item.user && item.user.name ? (item.user.name + ' ' + (item.user.last_name === null ? '' : item.user.last_name)) : 'N/A'}}
          </template>
          <template v-slot:item.site:name="{ item }">
            {{item.site && item.site.name ? item.site.name : 'N/A'}}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      loadingTable: false,
      loadingButton: false,
      menu: false,
      menu2: false,
      options: {
        itemsPerPage: 15,
        page: 1,
        total: 0
      },
      optionsDataTable: {
        itemsPerPage: 15,
        page: 1,
        total: 0
      },
      filter: {
        site_id: null,
        inpector_id: null,
        dateRange: true,
        date_start: this.returnFirstDayMount(),
        date_end: this.returnUltimateDayMount()
      },
      report2: [],
      sites: [],
      users: []
    }
  },
  watch: {
    sites (val) {
      if (val.length > 0) this.options.itemsPerPage = 10
    },
    'filter.dateRange' (val) {
      if (!val) {
        this.filter.date_start = null
        this.filter.date_end = null
      } else {
        this.filter.date_start = this.returnFirstDayMount()
        this.filter.date_end = this.returnUltimateDayMount()
      }
    }
  },
  computed: {
    headers () {
      return [
        {
          text: 'Inspector',
          align: 'center',
          value: 'user:name'
        },
        {
          text: this.$t('general.yard'),
          align: 'center',
          value: 'site:name'
        },
        {
          text: 'CheckList',
          align: 'center',
          value: 'name'
        },
        {
          text: this.$t('inspections.count'),
          align: 'center',
          value: 'total_inspection'
        },
        {
          text: this.$t('inspections.damageInspections'),
          align: 'center',
          value: 'total_inspection_critical'
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  created () {
    this.$store.dispatch('sites/get', { event: { context: this, item: { perPage: -1, page: 1 } } })
    this.$store.dispatch('users/getInspect', { event: { context: this, item: { perPage: -1, page: 1 } } })
    this.$store.dispatch('unitTypes/getAll', { event: { context: this } })
    this.get()
  },
  methods:{
    returnFirstDayMount() {
      const now = new Date()
      return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().substr(0, 10)
    },
    returnUltimateDayMount() {
      const now = new Date()
      return new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().substr(0, 10)
    },
    filterData(){
      if(!this.$refs.form.validate()) return this.showNotification(this.$t('general.errorFilterMessage'), 'warn', -1)
      
      this.optionsDataTable.page = 1
      
      this.get()
    },
    resetFilter(){
      this.filter = {
        site_id: null,
        inpector_id: null,
        dateRange: true,
        date_start: this.returnFirstDayMount(),
        date_end: this.returnUltimateDayMount()
      }

      this.optionsDataTable.page = 1
      
      this.get()
    },
    getInspector(user) {
     return `${user.name} ${user.last_name === null ? '' : user.last_name}`;
    },
    download () {
      if(!this.$refs.form.validate()) return this.showNotification(this.$t('general.errorFilterMessage'), 'warn', -1)

      this.loadingButton = true
      
      this.$store.dispatch('reports/getInspectionInspectorDoc', {
        event: {
          context: this,
          params: {
            ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'ASC' : 'DESC',
            perPage: this.optionsDataTable.itemsPerPage,
            page: this.optionsDataTable.page,
            type: 'download',
            date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
            date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
            site_id: this.filter.site,
            inpector_id: this.filter.inpector,
            sortKey: (this.optionsDataTable.sortBy && this.optionsDataTable.sortBy.length > 0) ? this.optionsDataTable.sortBy[0] : 'total_inspection_critical',
          }
        }
      })
    },
    get () {
      this.loadingTable = true
      this.$store.dispatch('reports/getInspectionInspector', {
        event: {
          context: this,
          params: {
            date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
            date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
            inpector_id: this.filter.inpector,
            site_id: this.filter.site,
            page: this.optionsDataTable.page,
            perPage: this.optionsDataTable.itemsPerPage,
            type: 'json',
            sortKey: (this.optionsDataTable.sortBy && this.optionsDataTable.sortBy.length > 0) ? this.optionsDataTable.sortBy[0] : 'total_inspection_critical',
            ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'ASC' : 'DESC'
          }
        }
      })
    },
    handleDateStartSelection(date) {
    this.filter.date_start = date;
    this.updateDateEnd();
    this.menu = false;
    },
    allowedStartDates() {
      return true;
    },
    allowedEndDates(date) {
      if (!this.filter.date_start) return true;

      const startDate = new Date(this.filter.date_start);
      const endDateLimit = new Date(startDate);
      endDateLimit.setDate(startDate.getDate() + 29); // 30 días adelante

      return new Date(date) >= startDate && new Date(date) <= endDateLimit;
    },
    updateDateEnd() {
      if (this.filter.date_start) {
        const startDate = new Date(this.filter.date_start);
        const endDateLimit = new Date(startDate);
        endDateLimit.setDate(startDate.getDate() + 29); // 30 días adelante

        this.filter.date_end = endDateLimit.toISOString().substr(0, 10);
      }
    },
    getDayStyle(date) {
      if ((this.filter.date_start && this.allowedEndDates(date)) || (!this.filter.date_start && this.allowedStartDates(date))) {
        return null; // Fechas habilitadas mantienen estilo normal
      }
      return { backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'gray' }; // Fechas deshabilitadas
    }
  }
}
</script>